{
  "key": "federation-drive-strips",
  "title": "Federation Drive nature strips",
  "suburb": "Federation Drive",
  "locationGroup": "nature-strips",
  "grassType": "buffalo",
  "cellM": 0.5,
  "w": 90,
  "h": 16,
  "rows": [
    "..........................................................................................",
    "eeeeeeeeeppppppeeeeeeeeeeeeppppppeeeeeeeeppppppeeeeeeeeeeeppppppeeeeeeeeeeppppppeeeeeeeeee",
    "pppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppp",
    "pppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppp",
    "gggggggggppppppgggggggggggoppppppggggggggppppppggggggggggoppppppggggggggggppppppgggggggggg",
    "gggggggggppppppggggggggggggppppppggggggggppppppgggggggggggppppppggggggggggppppppgggggggggg",
    "gggggggggppppppgggggoggggggppppppggggggggppppppgggggggggggppppppggggooggggppppppgggggggggg",
    "gggggggggppppppgggggoggggggppppppggggggggppppppgooooooooogppppppggggooggggppppppoooooooogg",
    "gggggggggppppppggggggggggggppppppggggggggppppppgooooooooogppppppggggggggggppppppoooooooogg",
    "gggggggggppppppggggggggggggppppppggggggggppppppgooooooooogppppppggggggggggppppppoooooooogg",
    "gggggggggppppppggggggggggggppppppggggggggppppppgggggggggggppppppggggggggggppppppgggggggggg",
    "pppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppp",
    "..........................................................................................",
    "..........................................................................................",
    "..........................................................................................",
    ".........................................................................................."
  ],
  "zoneRows": [
    "..........................................................................................",
    "..........................................................................................",
    "..........................................................................................",
    "..........................................................................................",
    "NNNNNNNNN......NNNNNNNNNNNN......NNNNNNNN......NNNNNNNNNNN......NNNNNNNNNN......NNNNNNNNNN",
    "NNNNNNNNN......NNNNNNNNNNNN......NNNNNNNN......NNNNNNNNNNN......NNNNNNNNNN......NNNNNNNNNN",
    "NNNNNNNNN......NNNNNNNNNNNN......NNNNNNNN......NNNNNNNNNNN......NNNNNNNNNN......NNNNNNNNNN",
    "NNNNNNNNN......NNNNNNNNNNNN......NNNNNNNN......NNNNNNNNNNN......NNNNNNNNNN......NNNNNNNNNN",
    "NNNNNNNNN......NNNNNNNNNNNN......NNNNNNNN......NNNNNNNNNNN......NNNNNNNNNN......NNNNNNNNNN",
    "NNNNNNNNN......NNNNNNNNNNNN......NNNNNNNN......NNNNNNNNNNN......NNNNNNNNNN......NNNNNNNNNN",
    "NNNNNNNNN......NNNNNNNNNNNN......NNNNNNNN......NNNNNNNNNNN......NNNNNNNNNN......NNNNNNNNNN",
    "..........................................................................................",
    "..........................................................................................",
    "..........................................................................................",
    "..........................................................................................",
    ".........................................................................................."
  ],
  "zones": [
    {"id":"nature-strip","rangeMm":[50,70]}
  ],
  "rangeMm": [50,70],
  "startLengthMm": [90,140],
  "props": [
    {"id":"letterbox-1","kind":"letterbox","x":4.25,"y":0.75,"w":0.4,"h":0.3,"solid":true},
    {"id":"letterbox-2","kind":"letterbox","x":13.25,"y":2.25,"w":0.4,"h":0.3,"solid":true},
    {"id":"letterbox-3","kind":"letterbox","x":20.25,"y":0.75,"w":0.4,"h":0.3,"solid":true},
    {"id":"letterbox-4","kind":"letterbox","x":28.75,"y":2.25,"w":0.4,"h":0.3,"solid":true},
    {"id":"letterbox-5","kind":"letterbox","x":36.75,"y":0.75,"w":0.4,"h":0.3,"solid":true},
    {"id":"letterbox-6","kind":"letterbox","x":44.25,"y":0.75,"w":0.4,"h":0.3,"solid":true},
    {"id":"gum-tree-1","kind":"gum-tree","x":10.25,"y":3.5,"r":0.45,"solid":true,"canopyR":3.6},
    {"id":"gum-tree-2","kind":"gum-tree","x":34.5,"y":3.5,"r":0.45,"solid":true,"canopyR":3.6},
    {"id":"car-1","kind":"car","x":6.5,"y":7,"w":4.5,"h":1.8,"solid":true},
    {"id":"car-2","kind":"car","x":30,"y":7,"w":4.5,"h":1.8,"solid":true},
    {"id":"car-3","kind":"car","x":26.25,"y":4.25,"w":4.4,"h":1.8,"solid":true},
    {"id":"car-4","kind":"car","x":42,"y":4.25,"w":4.2,"h":1.8,"solid":true},
    {"id":"power-pit-1","kind":"power-pit","x":2.75,"y":2.75,"w":0.4,"h":0.4,"solid":false},
    {"id":"power-pit-2","kind":"power-pit","x":18.25,"y":4.75,"w":0.4,"h":0.4,"solid":false}
  ],
  "spawn": {"x":1.25,"y":5.75,"heading":0},
  "utePark": {"x":1.75,"y":5.75,"heading":0},
  "weedFraction": 0.25,
  "leaves": {"count":[120,200],"areas":[{"x":7,"y":1,"w":7,"h":5},{"x":31,"y":1,"w":7,"h":5}]},
  "camera": {"fit":"follow","allowLandscape":true},
  "mutations": ["bin-night","magpie-season","bindii","heavy-leaves","ibis","hot-day"]
}
